import React, { useState, useEffect } from 'react';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogAction,
  AlertDialogCancel,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";

export function AgeVerification({ isHomePage = false }: { isHomePage?: boolean }) {
  const [showDialog, setShowDialog] = useState(false);

  useEffect(() => {
    // Best practice: gate the entire site, not just the homepage.
    // (We keep the prop for compatibility, but we don't rely on it.)
    try {
      const verified = localStorage.getItem("ageVerified") === "true";
      if (verified) {
        setShowDialog(false);
        return;
      }
    } catch {
      // If storage is unavailable, still show the dialog.
    }

    setShowDialog(true);
  }, [isHomePage]);

  const handleVerify = () => {
    try {
      localStorage.setItem("ageVerified", "true");
    } catch {
      // ignore
    }
    setShowDialog(false);
  };

  const handleDeny = () => {
    window.location.href = 'https://laydownnow.com';
  };

  return (
    <AlertDialog
      open={showDialog}
      onOpenChange={(nextOpen) => {
        // Prevent dismissing the gate via escape/outside click.
        if (nextOpen) setShowDialog(true);
      }}
    >
      <AlertDialogContent
        className="z-[1010] max-w-[min(92vw,460px)] border-[#d69b13]/55 bg-[#05170d] p-0 text-[#f7edd7] shadow-[0_28px_90px_rgba(0,0,0,0.55)]"
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <div className="rounded-lg border border-[#f0c766]/20 bg-[radial-gradient(circle_at_50%_0%,rgba(214,155,19,0.18),transparent_18rem)] p-6 sm:p-8">
          <AlertDialogHeader className="space-y-4 text-left">
            <div className="text-xs font-black uppercase tracking-[0.22em] text-[#f0c766]">
              Liquid Stretch
            </div>
            <AlertDialogTitle className="font-serif text-3xl leading-tight text-[#f7edd7]">
              Age Verification Required
            </AlertDialogTitle>
            <AlertDialogDescription className="text-base leading-7 text-[#cfc3aa]">
              Liquid Stretch contains hemp-derived cannabinoids and is intended for
              adults 21 and older. Please confirm your age before entering.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="mt-7 grid gap-3 sm:grid-cols-2 sm:space-x-0">
            <AlertDialogCancel asChild>
              <Button
                variant="outline"
                onClick={handleDeny}
                className="min-h-12 border-[#d69b13]/55 bg-transparent font-black text-[#f0c766] hover:border-[#f0c766] hover:bg-[#123820] hover:text-[#f7edd7]"
              >
                No, I'm not
              </Button>
            </AlertDialogCancel>
            <AlertDialogAction asChild>
              <Button
                onClick={handleVerify}
                className="min-h-12 border border-[#f0c766] bg-[#f0c766] font-black text-[#150f04] hover:bg-[#d69b13] hover:text-[#150f04]"
              >
                Yes, I'm over 21
              </Button>
            </AlertDialogAction>
          </AlertDialogFooter>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
